<script>
import { mapState } from "vuex";
import Languages from "@/components/widgets/languages";

export default {
  locales: {
    pt: {
      'Settings': 'Configurações',
      'My Account': 'Minha Conta',
      'My Address': 'Meus Endereços',
      'Bank Account': 'Conta Bancária',
      'My Password': 'Minha Senha',
      'Password Security' : 'Senha de Segurança',
      'Logout': 'Sair',
    },
    es: {
      'Settings': 'Configuraciones',
      'My Account': 'Mi Cuenta',
      'My Address': 'Mi Endereços',
      'Bank Account': 'Cuenta Bancaria',
      'My Password': 'Mi Contraseña',
      'Password Security' : 'Contraseña de Seguridad',
      'Logout': 'Cerrar Sesión',
    }
  },
  components: { Languages },
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({})
    },
    isCondensed: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      account: state => state.account
    })
  },
  created() {
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    }
  }
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <button id="vertical-menu-btn" class="d-block d-lg-none btn btn-sm px-3 font-size-20 header-item" type="button" @click="toggleMenu">
          <i class="fa fa-fw fa-bars"></i>
        </button>
      </div>

      <div class="d-flex">
        <router-link tag="a" to="/" class="logo">
          <img class="mr-2" style="height:60px;" src="@/assets/images/logo-icon-white.png" />
          <img style="height:30px;" src="@/assets/images/logo-white.png" />
        </router-link>
      </div>

      <div class="d-flex pr-2">
        <Languages class="d-none"></Languages>
        <router-link tag="a" to="/account">
          <template v-if="account.user">
            <img v-if="account.user.avatar" class="rounded-circle header-profile-user" :src="account.user.avatar" alt="" />
            <img v-else class="rounded-circle header-profile-user" :src="'https://ui-avatars.com/api/?background=112F47&color=fff&name=' + account.user.name" alt="" />
          </template>
        </router-link>
      </div>
    </div>
  </header>
</template>
